__turbopack_context__.v({
  "articleTimeAgo": "QuoteAltSuggestions-module-scss-module__sjU00q__articleTimeAgo",
  "articleTitle": "QuoteAltSuggestions-module-scss-module__sjU00q__articleTitle",
  "articleTopic": "QuoteAltSuggestions-module-scss-module__sjU00q__articleTopic",
  "banner": "QuoteAltSuggestions-module-scss-module__sjU00q__banner",
  "card": "QuoteAltSuggestions-module-scss-module__sjU00q__card",
  "cardFooter": "QuoteAltSuggestions-module-scss-module__sjU00q__cardFooter",
  "empty": "QuoteAltSuggestions-module-scss-module__sjU00q__empty",
  "icon": "QuoteAltSuggestions-module-scss-module__sjU00q__icon",
  "list": "QuoteAltSuggestions-module-scss-module__sjU00q__list",
  "listHeader": "QuoteAltSuggestions-module-scss-module__sjU00q__listHeader",
  "listWrapper": "QuoteAltSuggestions-module-scss-module__sjU00q__listWrapper",
  "name": "QuoteAltSuggestions-module-scss-module__sjU00q__name",
  "nameWrapper": "QuoteAltSuggestions-module-scss-module__sjU00q__nameWrapper",
  "negative": "QuoteAltSuggestions-module-scss-module__sjU00q__negative",
  "newsHeader": "QuoteAltSuggestions-module-scss-module__sjU00q__newsHeader",
  "newsList": "QuoteAltSuggestions-module-scss-module__sjU00q__newsList",
  "newsWrapper": "QuoteAltSuggestions-module-scss-module__sjU00q__newsWrapper",
  "oops": "QuoteAltSuggestions-module-scss-module__sjU00q__oops",
  "percent": "QuoteAltSuggestions-module-scss-module__sjU00q__percent",
  "positive": "QuoteAltSuggestions-module-scss-module__sjU00q__positive",
  "price": "QuoteAltSuggestions-module-scss-module__sjU00q__price",
  "row": "QuoteAltSuggestions-module-scss-module__sjU00q__row",
  "text": "QuoteAltSuggestions-module-scss-module__sjU00q__text",
  "ticker": "QuoteAltSuggestions-module-scss-module__sjU00q__ticker",
  "wrapper": "QuoteAltSuggestions-module-scss-module__sjU00q__wrapper",
  "wrapperGradient": "QuoteAltSuggestions-module-scss-module__sjU00q__wrapperGradient",
});
